import { useStore } from "@/store";
import { Domain } from "@/schemas";

export interface DomainsResult {
  // Domain State
  domains: Domain[];
  currentDomain: Domain | null;
  isLoadingDomains: boolean;
  hasLoadedDomains: boolean;
  error: string | null;

  // Domain Actions
  setCurrentDomainId: (domainId: string | null) => Promise<void>;
  addDomain: (orgId: string, url: string) => Promise<string>;
  deleteDomain: (orgId: string, domainId: string) => Promise<void>;
}

/**
 * Custom hook to access and manage domain-related data and operations
 */
export const useDomains = (): DomainsResult => {
  const {
    // Domain state
    domains,
    currentDomain,
    isLoadingDomains,
    hasLoadedDomains,
    domainError,

    // Domain actions
    setCurrentDomainId,
    addDomain,
    deleteDomain,
  } = useStore();

  return {
    // Domain state
    domains,
    currentDomain,
    isLoadingDomains,
    hasLoadedDomains,
    error: domainError,

    // Domain actions
    setCurrentDomainId,
    addDomain,
    deleteDomain,
  };
};
